module.exports = __webpack_public_path__ + "img/fighter.e208f8a6.svg";